import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/auth.service';
import { AFSummaryOfRights } from 'src/app/model/af.model';

@Component({
  selector: 'app-summary-of-rights',
  templateUrl: './summary-of-rights.component.html',
  styleUrls: ['./summary-of-rights.component.scss']
})
export class SummaryOfRightsComponent implements OnInit {

  language: string;

  constructor(private userService: AuthService) { }

  ngOnInit() {
    this.subscribeEvent();
  }

  subscribeEvent() {
    this.userService.getSummaryLanguage().subscribe({
      next: (data: AFSummaryOfRights) => {
        this.language = data.languageLookup;
      }
    });
  }

}
